
import React from 'react';

const Services = () => {
  const services = [
    {
      icon: 'ri-settings-3-line',
      title: 'Software Licensing & Procurement',
      description: 'Official reseller and implementation partner for ManageEngine, AutomMate, and Zoho One solutions with comprehensive licensing support.',
      features: ['ManageEngine Suite', 'AutomMate Platform', 'Zoho One Ecosystem', 'Volume Licensing']
    },
    {
      icon: 'ri-tools-line',
      title: 'Implementation & Configuration',
      description: 'End-to-end setup and optimization of ITSM, ITOM, RPA, and integrated automation solutions tailored to your business needs.',
      features: ['ITSM Setup', 'ITOM Configuration', 'RPA Deployment', 'System Optimization']
    },
    {
      icon: 'ri-links-line',
      title: 'Integration Services',
      description: 'Connecting ManageEngine modules with enterprise tools such as Microsoft 365, SAP, HR, and CRM systems for seamless operations.',
      features: ['API Integration', 'Data Synchronization', 'Workflow Automation', 'System Connectivity']
    },
    {
      icon: 'ri-robot-line',
      title: 'Business Process Automation',
      description: 'Design and deployment of workflow automation using AutomMate to eliminate repetitive tasks and streamline operations.',
      features: ['RPA Solutions', 'Workflow Design', 'Task Automation', 'Process Optimization']
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Consulting & ITIL Process Design',
      description: 'Advisory and implementation of ITIL-aligned service models, process maturity assessments, and service catalog design.',
      features: ['ITIL Consulting', 'Process Design', 'Service Catalog', 'Maturity Assessment']
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Training & Enablement',
      description: 'Structured learning programs covering ITIL fundamentals, ITSM best practices, automation workflows, and platform expertise.',
      features: ['ITIL Training', 'Platform Certification', 'Best Practices', 'Skill Development']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">Our Core Services</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive technology solutions that bridge people, processes, and platforms to ensure improved productivity, operational efficiency, and compliance with global IT standards.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h4>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a href="/services">
            <button className="mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              Services
            </button>
          </a>
        </div>

      </div>
    </section>
  );
};

export default Services;
